import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
  Modal,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";
import { DownloadIcon, SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import calendarIcon from "../../assets/images/onleave/calendar.svg";
// import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconEdit from "../../assets/images/product/edit.svg";
import iconAdd from "../../assets/images/booking/plus-square.svg";
import icontrash from "../../assets/images/product/trash.svg";
import { AiOutlineMore } from "react-icons/ai";
import DeleteDialog from "../../components/dialog/delete";
import { useForm } from "react-hook-form";
import AddOpenForSale from "./formOpenForSale/addOpenForSale";
import AddProduct from "./formOpenForSale/addProduct";
import DatePicker from "react-datepicker";
import SearchableSelect from "../../components/selectForm";
import toast from "react-hot-toast";
import useDebounce from "../../hooks/useDebounce";
import { useSaleOpeningEvent } from "../../hooks/useSaleOpeningEvent";
import { useCategories } from "../../categorys/openForSale/index";
import { saleOpeningEventCall } from "../../api/saleOpeningEvent";
import { apartmentSaleOpeningEventLinkCall } from "../../api/apartmentSaleOpeningEventLink";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import PopupSaleOpeningEvent from "../../components/popup/popupSaleOpeningEvent";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { useNavigate } from "react-router-dom";
import PopupImport from "../../components/popup/PopupImport";
import iconTextFile from "../../assets/images/employee/file-text (2).svg";
import iconFile from "../../assets/images/projectManagement/file-text.svg";
import iconClose from "../../assets/images/projectManagement/x-circle.svg";
import { exportFile } from "../../utils/tools";
import KRatePrivate from "./formOpenForSale/kRatePrivate";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const columnMappingEmployee = {
  "Mã căn": "code",
  "Giá tính phí dịch vụ": "priceForCommission",
  "Tỉ lệ TN sàn": "rateTNSan",
  "Số tiền TN sàn": "priceTNSan",
};

const TableApartments = ({ isRefetchingWithCreate, paramData }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const navigate = useNavigate();

  const {
    isOpen: isOpenDownloadFile,
    onOpen: onOpenDownloadFile,
    onClose: onCloseDownloadFile,
  } = useDisclosure();
  const {
    isOpen: isOpenSaleOpeningEvent,
    onOpen: onOpenSaleOpeningEvent,
    onClose: onCloseSaleOpeningEvent,
  } = useDisclosure();

  const {
    isOpen: isOpenKRatePrivate,
    onOpen: onOpenKRatePrivate,
    onClose: onCloseKRatePrivate,
  } = useDisclosure();

  // table
  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [projectId, setProjectId] = useState([]);
  const [popupDelete, setPopupDelete] = useState(false);
  const [isAddBooking, setIsAddBooking] = useState(false);
  const [dataEdit, setDataEdit] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupVisibleImport, setPopupVisibleImport] = useState(false);
  const [apartment, setApartment] = useState([]);
  const [fileDownload, setFileDownload] = useState([]);
 
  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    saleOpeningEventData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useSaleOpeningEvent(debouncedSearchTerm, startDate, endDate, projectId);

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    paramData({
      search: debouncedSearchTerm,
      startDate,
      endDate,
      projectId,
    });
  }, [debouncedSearchTerm, startDate, endDate, projectId]);

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "MĐMB",
        key: "code",
      },
      {
        label: "Tên đợt mở bán",
        key: "name",
      },
      {
        label: "Tên dự án",
        key: "project",
      },
      {
        label: "Số sản phẩm",
        key: "product",
      },
      {
        label: "Thời gian bắt đầu",
        key: "startTime",
      },
      {
        label: "Thời gian kết thúc",
        key: "endTime",
      },
      {
        label: "Số tiền đặt cọc",
        key: "price",
      },
      {
        label: "Nhân viên tạo",
        key: "creator",
      },
      // {
      //   label: "Ngày tạo",
      //   key: "createdAt",
      // },
    ],
    data: saleOpeningEventData,
  };

  const { constantData } = useCategories();

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );

  const handlePageChange = (selectedPage) => {
    setPopupDelete(false);
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const handlePopupDelete = (e) => {
    setPopupDelete(true);
    setDataEdit(e?.edit);
    onOpen();
  };

  const handlePopup = (type, e) => {
    setIsAddBooking(type);
    setPopupDelete(false);
    if (type) {
      setDataEdit(e?.edit);
      onOpen();
    } else {
      setDataEdit(e?.detail);
      onOpenSaleOpeningEvent();
    }
  };

  const handlePopupAddProduct = (type, e) => {
    setIsAddBooking(type);
    setPopupDelete(false);
    setDataEdit(e?.addProduct);
    onOpen();
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang sửa đợt mở bán ...");
    try {
      const { id, kRate, ...dataEdit } = data;
      await saleOpeningEventCall.update(id, dataEdit);

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const onSubmitDelete = async () => {
    const toastEdit = toast.loading("Đang xóa dữ liệu ...");
    try {
      const { id } = dataEdit;
      await saleOpeningEventCall.delete(id);
      await refetch();
      setDataEdit(null);
      onClose();
      toast.success("Xóa thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi xóa");
    }
    toast.dismiss(toastEdit);
  };

  const addProductBookingEvent = async (data) => {
    const toastCreate = toast.loading("Đang thêm sản phẩm vào đợt mở bán ...");
    try {
      await apartmentSaleOpeningEventLinkCall.create(data);

      await refetch();
      onToggle();
      onClose();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const handleNavigate = (e) => {
    navigate(`/sale-opening-event/sale-opening-event-mechanism/${e?.id}`);
  };

  const onPopupVisible = async (e) => {
    // setDataEdit(e);
    // if (e?.products?.length > 0) {
    //   setApartment(e?.products);
    //   setPopupVisible(true);
    // }

    navigate(
      `/sale-opening-event/sale-opening-event-mechanism-import/${e?.id}`
    );
  };

  const handleImport = async () => {
    setPopupVisibleImport(true);
  };

  const handleEmployeeExportSample = () => {
    const columnMapping = {
      apartment: "Mã căn",
      priceForCommission: "Giá tính phí dịch vụ",
      rateTNSan: "Tỉ lệ TN sàn",
      priceTNSan: "Số tiền TN sàn",
    };

    const data = apartment?.map((item) => ({
      apartment: item?.apartmentObject?.code,
      priceForCommission: "",
      rateTNSan: "",
      priceTNSan: "",
    }));

    try {
      exportFile(data, columnMapping, "Can_ho_trong_dot_mo_ban.xlsx");
      toast.success("Download file thành công");
    } catch (error) {
      toast.error("Export lỗi");
      console.log(error);
    }
  };

  const handleDownloadDocument = async (id) => {
    const toastDownload = toast.loading("Đang in tài liệu cơ chế ...");

    try {
      const downLoadDocument = await saleOpeningEventCall.downLoadDocument(id);

      setFileDownload([]);

      const newFiles = [];

      if (
        downLoadDocument?.items?.fileNamePDV &&
        downLoadDocument?.items?.filePathPDV
      ) {
        newFiles.push({
          name: downLoadDocument.items.fileNamePDV,
          path: `${baseURL}${downLoadDocument.items.filePathPDV}`,
        });
      }

      if (
        downLoadDocument?.items?.fileNameDuAn &&
        downLoadDocument?.items?.filePathDuAn
      ) {
        newFiles.push({
          name: downLoadDocument.items.fileNameDuAn,
          path: `${baseURL}${downLoadDocument.items.filePathDuAn}`,
        });
      }

      setFileDownload(newFiles);
      onOpenDownloadFile();
      toast.dismiss(toastDownload);
      toast.success("In hợp đồng dịch vụ thành công");
    } catch (error) {
      toast.dismiss(toastDownload);
      console.log({ error });
    }
  };

  const onDownLoad = async (file, name) => {
    try {
      const response = await fetch(file);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = name || file.name || "downloaded-file";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error:", err);
    }
  };

  const onPopupKRatePrice = (e) => { 
    setDataEdit(e?.edit);
    onOpenKRatePrivate();
  };

  const onHandleKRatePrice = async (data) => {
    const toastUpdate = toast.loading("Đang cập nhật hệ số K riêng dự án...");
    try {
      await saleOpeningEventCall.kRatePrivate(dataEdit?.id, data);

      await refetch();
      onCloseKRatePrivate();
      toast.success("Thêm thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastUpdate);
    }
    toast.dismiss(toastUpdate);
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Nhập tên đợt mở bán..."
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                <InputGroup w={"100%"} maxW={"255px"} zIndex={3}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    isClearable={true}
                    placeholderText="Từ ngày - Đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={projects}
                  // initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                  setValue={setProjectId}
                  placeholder={"Chọn dự án"}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "name") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "project") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "product") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "price") {
                          width = "10%";
                          textAlign = "start";
                        } else {
                          width = "10%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        delete items.addProduct;
                        delete items.products;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td
                              p={"16px 0px 8px 16px"}
                              w={"2%"}
                              bg={
                                rowIndex % 2 === 0
                                  ? "var(--color-main)"
                                  : "var(--fill-avatar)"
                              }
                            >
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                  p={0}
                                >
                                  <AiOutlineMore fontSize={"20px"} w="20px" />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(true, e)}
                                  >
                                    <Image src={iconEdit} /> Chỉnh sửa
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handleNavigate(e)}
                                  >
                                    <Image src={iconEdit} /> Quản lý hệ số K
                                  </MenuItem>
                                  {/* <MenuItem
                                    gap={"16px"}
                                    onClick={() => onPopupKRatePrice(e)}
                                  >
                                    <Image src={iconEdit} /> Cập nhật hệ số k
                                    riêng dự án
                                  </MenuItem> */}
                                  {e?.product > 0 && (
                                    <MenuItem
                                      gap={"16px"}
                                      onClick={() => onPopupVisible(e)}
                                    >
                                      <Image src={iconEdit} /> Import Giá tính
                                      PDV và TN sàn
                                    </MenuItem>
                                  )}
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handleDownloadDocument(e?.id)
                                    }
                                  >
                                    <Image src={iconTextFile} />
                                    In tài liệu cơ chế
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() =>
                                      handlePopupAddProduct(false, e)
                                    }
                                  >
                                    <Image src={iconAdd} /> Thêm sản phẩm
                                  </MenuItem>
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopupDelete(e)}
                                  >
                                    <Image src={icontrash} /> Xóa đợt mở bán
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "name") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "project") {
                                width = "10%";
                                textAlign = "start";
                                whiteSpace = "normal";
                                widthText = "118px";
                              } else if (keyvalue === "product") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "price") {
                                width = "10%";
                                textAlign = "start";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                  bg={
                                    rowIndex % 2 === 0
                                      ? "var(--color-main)"
                                      : "var(--fill-avatar)"
                                  }
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {!popupDelete ? (
        isAddBooking ? (
          <AddOpenForSale
            isOpen={isOpen}
            onClose={onClose}
            isEdit={true}
            defaultValues={dataEdit}
            onSubmit={onSubmitEdit}
          />
        ) : (
          <AddProduct
            isOpen={isOpen}
            onClose={onClose}
            isEdit={true}
            onSubmit={addProductBookingEvent}
            defaultValues={dataEdit}
          />
        )
      ) : (
        <DeleteDialog
          isOpen={isOpen}
          onClose={onClose}
          title="Xóa đợt mở bán"
          description={
            <Flex display={"inline"}>
              "Bạn có chắc chắn muốn xóa đợt mở bán{" "}
              <Text fontWeight={"600"} display={"inline"}>
                {dataEdit?.name}
              </Text>{" "}
              không?"
            </Flex>
          }
          action={() => onSubmitDelete()}
        />
      )}
      <PopupSaleOpeningEvent
        isOpen={isOpenSaleOpeningEvent}
        onClose={onCloseSaleOpeningEvent}
        defaultValue={dataEdit}
      />

      <KRatePrivate
        isOpen={isOpenKRatePrivate}
        onClose={onCloseKRatePrivate}
        defaultValues={dataEdit?.kRate ? { kRate: dataEdit.kRate } : {}}
        onSubmit={onHandleKRatePrice}
      />

      {popupVisible && (
        <PopupImport
          isOpen={popupVisible}
          onClose={() => setPopupVisible(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingEmployee}
          handleExport={handleEmployeeExportSample}
          titleAdd="Export giá tính phí dịch vụ và thưởng nóng sàn"
          inputAdd="Export giá tính phí dịch vụ và thưởng nóng sàn"
          type={"employeeImport"}
          // isTypePrice={true}
          exportTitle={"Export căn hộ có trong đợt mở bán"}
          isExport={true}
          titleImport={"Import giá tính phí dịch vụ"}
          onImport={handleImport}
        />
      )}

      {popupVisibleImport && (
        <PopupImport
          isOpen={popupVisibleImport}
          onClose={() => setPopupVisibleImport(false)}
          refetchCheckInData={refetch}
          columnMappingReverse={columnMappingEmployee}
          handleExport={handleEmployeeExportSample}
          titleAdd="Thêm giá tính phí dịch vụ và thưởng nóng sàn"
          inputAdd="Nhập giá tính phí dịch vụ và thưởng nóng sàn"
          type={"importCalculatorApartment"}
          isTypePrice={true}
          exportTitle={"Export căn hộ có trong đợt mở bán"}
          isImport={true}
          id={dataEdit._id || dataEdit.id}
        />
      )}

      <FileDownload
        isOpen={isOpenDownloadFile}
        onClose={onCloseDownloadFile}
        files={fileDownload}
        onDownLoad={onDownLoad}
      />
    </>
  );
};

const FileDownload = ({ isOpen, onClose, onDownLoad, files }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        borderRadius={"16px"}
        maxW={"825px"}
        maxH={"800px"}
        overflow="auto"
      >
        <Flex
          borderBottom={"1px solid var(--color-boder)"}
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"24px 20px 24px 24px"}
        >
          <Text fontSize={"18px"} fontWeight={600} lineHeight={"normal"}>
            Tài liệu
          </Text>
          <Image src={iconClose} onClick={onClose} cursor={"pointer"} />
        </Flex>
        <Box p={"24px"} backgroundColor={"var(--color-backgroundmain)"}>
          <Box
            flex={1}
            // w={"545px"}
            backgroundColor={"var(--color-main)"}
            borderRadius={"16px"}
            p={"16px 0"}
          >
            <TableContainer w={"100%"}>
              <Table
                w={"100%"}
                variant="unstyled"
                // border={"1px solid var(--color-boder)"}
              >
                <Thead
                  w={"100%"}
                  h={"41px"}
                  fontWeight="400"
                  borderBottom={"1px solid var(--color-boder)"}
                  bg={"var(--color-main)"}
                >
                  <Tr h={{ base: "41px" }}>
                    <Td
                      p={"16px 16px 12px 16px"}
                      border={"none"}
                      color={"#51607B"}
                      fontSize={{ base: "14px" }}
                    >
                      Tên file
                    </Td>
                    <Td
                      p={"16px 16px 12px 16px"}
                      border={"none"}
                      color={"#51607B"}
                      fontSize={{ base: "14px" }}
                    >
                      Tải xuống
                    </Td>
                  </Tr>
                </Thead>
                <Tbody w={"100%"} h={"100%"}>
                  {files.map((item, index) => (
                    <Tr
                      key={index}
                      w={"100%"}
                      h={"42px"}
                      backgroundColor={
                        index % 2 === 0
                          ? "var(--color-main)"
                          : "var(--fill-avatar)"
                      }
                    >
                      <Td
                        p={"16px 16px 8px 16px"}
                        w={"80%"}
                        verticalAlign={"center"}
                      >
                        <Flex gap={"4px"} alignItems={"center"}>
                          <Image src={iconFile} />
                          {item?.name
                            ? item?.name
                            : item?.file ||
                              "Đây là tên tài liệu của đợt mở bán"}
                        </Flex>
                      </Td>
                      <Td
                        p={"16px 16px 8px 16px"}
                        w={"20%"}
                        textAlign={"center"}
                        verticalAlign={"center"}
                      >
                        <Button
                          bg={"none"}
                          leftIcon={
                            <DownloadIcon color={"var(--color-secondary)"} />
                          }
                          colorScheme="teal"
                          onClick={() =>
                            onDownLoad(
                              item?.path ? item?.path : "",
                              item?.name || ""
                            )
                          }
                          _hover={{
                            filter: "brightness(90%)",
                          }}
                          p={"0px"}
                          w={"max-content"}
                          position={"relative"}
                        ></Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default TableApartments;
